import { connect } from "react-redux";
import UpdateSecurityQuestion from "../components/ResetPassword/UpdateSecurityQuestion";
import * as selector from "../redux/selectors/accountSettingSelector";
import * as actions from "../redux/actions/ResetPassword";
import { getUser } from "../redux/actions/AccountSetting";
import { push } from "react-router-redux";

const mapStateToProps = (state) => {
  return {
    user: selector.getUser(state),
    error: state.resetPassword.error,
    isResetting: state.resetPassword.resetting,
    message: state.resetPassword.message,
    shortMessage: state.resetPassword.shortMessage,
    errorMessage: state.resetPassword.errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUserInfo() {
    dispatch(getUser());
  },

  postUsersUpdatePassword(data) {
    dispatch(actions.postUsersUpdatePassword(data));
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateSecurityQuestion);



// WEBPACK FOOTER //
// ./src/containers/UpdateSecurityQuestion.js